import { Center, Drawer, Text, useMantineTheme } from '@mantine/core'
import { useDisclosure, useMediaQuery } from '@mantine/hooks'
import { IconInfoCircle } from '@tabler/icons-react'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { StyledRoundedButton } from '../../styled/components'
import RootButton from '../Buttons/RootButton'
import classes from './HelpDrawer.module.css'
import HelpDrawerData from './HelpDrawerData'

interface HelpDrawerProps {
  id?: string
  title?: string
  content?: JSX.Element
  icon?: JSX.Element
  extraLink?: string
}

const HelpDrawer: React.FC<HelpDrawerProps> = ({
  id = '',
  title,
  content = <></>,
  icon = undefined,
  extraLink = undefined,
}) => {
  const { t } = useTranslation()
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  title = title ?? t('components.helpDrawer.title', 'Help Drawer')
  const [opened, { open, close }] = useDisclosure(false)

  const handleButtonClick = useCallback(() => {
    if (opened) {
      close()
    } else {
      open()
    }
  }, [opened, open, close])

  return (
    <Center>
      <Drawer.Root
        opened={opened}
        onClose={close}
        size="md"
        position="right"
        className={classes.drawer}
        lockScroll={false}
      >
        <Drawer.Overlay />
        <Drawer.Content>
          <Drawer.Header>
            <Drawer.Title className={classes.drawerTitle}>{title}</Drawer.Title>
            <Drawer.CloseButton />
          </Drawer.Header>
          <Drawer.Body>
            {id !== '' && <HelpDrawerData id={id} />}
            {content}
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Root>
      {!extraLink ? (
        <StyledRoundedButton className={classes.questionMarkButton} onClick={handleButtonClick}>
          {!icon && <Text className={classes.questionMarkText}>?</Text>}
          {icon !== undefined && icon}
        </StyledRoundedButton>
      ) : isMobile ? (
        <IconInfoCircle
          style={{ width: '20px', height: '20px', color: theme.colors.l1Primary[0] }}
          onClick={handleButtonClick}
        />
      ) : (
        <RootButton style1={false} secondary onClick={handleButtonClick}>
          {extraLink}
        </RootButton>
      )}
    </Center>
  )
}

export default HelpDrawer
